import { useCategoryRelease } from '../utils/useCategoryRelease';
import { useVendor } from '../VendorPovider/VendorPovider';
import { PromoBadge } from '../PromoBadge/PromoBadge';

import type { SvpCategoryAdditional } from '@vgtv/api-client/lib/svp_category';
import type { FC } from 'react';

import * as styles from './CategoryThumbnail.module.scss';

interface CategoryPromoBadgeProps {
  category: SvpCategoryAdditional;
}

export const CategoryPromoBadge: FC<CategoryPromoBadgeProps> = ({
  category,
}) => {
  const { vendor } = useVendor();
  const { variant } = useCategoryRelease({
    category,
    vendor,
  });

  return variant ? (
    <div className={styles.badge}>
      <PromoBadge variant={variant} />
    </div>
  ) : null;
};
